import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { AchievementItem } from './AchievementItem';
import { motion } from 'framer-motion';
import { Sprite } from './Sprite';
import { observable } from 'mobx';
import { B64Image } from './B64Image';

const Wrap = styled.div`
	flex: 1 1 100px;
	position:relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100vw;
	height: 100%;
	box-sizing: border-box;
	padding-top: ${p => p.modal ? '17vw' : 0};
	background: ${p => p.modal ? 'rgba(0,0,0,0.5)' : 'none'};
	overflow: hidden;
`

const Body = styled(motion.div)`
	flex: 1 1 116vw;
	overflow: visible;
	text-align: center;
	color: black;
	position: relative;
	&::-webkit-scrollbar { width: 0 !important }
	flex-direction: column;
	display: flex;
	width: 100%;
	padding: 12.5vw 0 0 0;
	box-sizing: border-box;
`

const Content = styled.div`
	background-image: url('/assets/achievements/panel_02.png');
	background-size: 100% 100%;
	flex: 1 1 100px;
	display: flex;
	overflow: hidden;
	padding: 0 0.5vw;
`

const Scroller = styled.div`
	margin: 0 auto;
	overflow: auto;
	position: relative;
	padding-bottom: 10px;
	flex: 1 1 100px;
	display: flex;
	flex-direction: column;
	-webkit-overflow-scrolling: touch;
	overflow: scroll;
`

const Header = styled(motion.div)`
	width: 100vw;
	top: ${p => p.modal ? '20vw' : '2vw'};
	position: absolute;
	text-align: center;
	z-index: 100;
	& > img {
		width: 100%;
	}
`

const CloseButton = styled.img`
	width: 12vw !important;
	position: absolute;
	top: -3vw;
	right: 9vw;
	z-index: 1000;
`

@observer
export class Achievements extends Component {

	@observable dataReady = false;

	constructor(props){
		super(props);
		store.user.updateAchievements()
		.then(() => {
			this.dataReady = true;
		});
	}

	close = () => {
		window.manager.playAudio("poopPop");
		store.showAchievements = false;
	}

	render(){

		if(!this.dataReady){
			return <div></div>
		}

		var a = {scale: 1, transition:{delay: 1}};
		return (
			<Wrap	modal={this.props.modal}>
				<Header
				initial={{scale: 0}}
				animate={a}
				modal={this.props.modal}
				>
					{this.props.modal && <CloseButton src="/assets/btn_close.png" onClick={() => this.close()}/>}
					<Sprite w={100} unit="%" localize sprite="achievements_profile_banner_english.png"/>
				</Header>
				<Body
				initial={{top: '100vh'}}
				animate={{
					top: 0,
					transition: {delay: 0.5}
				}}>
					<B64Image alt="" style={{width: '100vw', height: '12.5vw'}} src="/assets/achievements/panel_01.png"/>
					<Content>
						<Scroller className="scroller">
							{store.user.achievements
							.filter(a => a.Current.Type !== 'tutorial')
							.map((a, i) => (
								<AchievementItem key={a.Current.Type} i={i}/>
							))}
						</Scroller>
					</Content>
					{this.props.modal && <B64Image alt="" style={{width: '100vw', height: '7.656vw', marginBottom: '10vw'}} src="/assets/achievements/panel_03.png"/>}
				</Body>
			</Wrap>
		);
	}
}
